import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form } from './Form';
import { fetchCreatePassword } from '@app/src/views/Login/createPassword/state/createPassword/actions';
import * as selectUser from '@app/src/views/Login/createPassword/state/createPassword/selectors';
import * as selecToken from '@app/src/views/Login/createPassword/state/validateToken/selector';

const FormContainer = reduxForm({
  form: 'PasswordForm',
  onSubmit (fields, dispatch, { url }) {
    dispatch(fetchCreatePassword(fields, url));
  }
})(Form);

const mapStateToProps = state => ({
  errorMessage: selectUser.getErrorMessage(state) || selecToken.getErrorMessage(state),
  isFetching: selectUser.getIsFetching(state)
});

const FormContainerState = connect(
  mapStateToProps
)(FormContainer)

export default FormContainerState;
